import Backdraft from "backdraft-app/src/backdraft";
import _ from "underscore";

Backdraft.app("Shared/SignalExpression", function(app) {
  app.model("PoolParamTerminal", "StringCompareTerminal", {
    defaults: {
      relop: "=",
      value: "",
      pool_param_name: ""
    },

    initialize: function() {
      this.on('change:relop', function() {
        if (this.get('relop') === "present") {
          this._triggerValidations();
        }
      });

      this.on('change:pool_param_name', function() {
        if (this.previousAttributes().pool_param_name === "" && this.get('pool_param_name') !== "") {
          this._triggerValidations();
        }
      });
    },

    type: function() {
      return 'PoolParam';
    },

    validate: function() {
      var errors = [];

      if (this._shouldAddValueErrors()) { errors.push(this._valueError()); }
      if (this.get("pool_param_name") === "" || this.get("pool_param_name") === undefined) {
        errors.push("expected pool_param['key'] = 'value', key cannot be empty");
      }

      if (!_.isEmpty(errors)) { return errors; }
    },

    _textPrefix: function() {
      return "pool_param" + "[" + this.get('pool_param_name') + "]";
    }
  });
});
